<template>
  <el-button type="text" size="small" @click="delHandle">
    <slot></slot>
  </el-button>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      submitIng: false,
      form: {
        id: ''
      }
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  mounted() {},
  methods: {
    delHandle() {
      const _this = this;
      _this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.submitIng = false;
        _this.form.id = _this.id
        _this.$api.wareOrderDelete(_this.form)
            .then(res => {
              _this.submitIng = false;
              _this.$emit('finish', res);
              _this.$message.success('删除成功');
            })
            .catch(err => {
              _this.submitIng = false;
              _this.$message.error(err.msg);
            })
      }).catch(() => {
      });
    }
  },
};
</script>